var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.userId)?_c('home'):_c('login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }